// @ts-nocheck
/* eslint-disable react/prop-types */
// LIBRARY
import React from 'react';
import { Drawer, Form, Input, Button, Select, Spin, Switch, Row, message, Modal } from 'antd';
import PropTypes from 'prop-types';
import {
	// Exam result Type Codes
	EITC_ALPHA_NUMERIC,
	EITC_NUMERIC,
	EITC_CHECKBOX,
	EITC_OPTION,
	EITC_TEXT_AREA,
} from 'global_config/constant-global';
import { UserAccessContext } from 'context/userAccess';
import { AlphaNumInput, RegexInput, NumberInput } from 'shared_components/pattern_input';
import { updateExamItem, fetchExamItem } from 'services/settings/examItem';
import { deactivateItem } from 'services/settings/status';
import { showMessage } from 'services/settings/message';
import { fetchUnitOfMeasureItems } from 'services/settings/lookup_table/unitOfMeasure';
import getInputTypeCode from 'services/settings/inputType';
import showDeactivationModal from 'shared_components/deactivation_modal';
import showIntegrationCodeModal from 'shared_components/integration_code_modal';
import { fieldRules, drawerTitle, fieldLabels, buttonNames } from '../settings';
import DynamicForm from '../dynamic_form';
import DynamicFormAnalyzer from '../dynamic_form_analyzer';

// CSS
import './update_form.css';

const { Option } = Select;
const { TextArea } = Input;

/** @type {{footer: React.CSSProperties, fullWidth: React.CSSProperties }} */
const styles = {
	fullWidth: {
		width: '100%',
	},
	footer: {
		position: 'absolute',
		width: '100%',
		bottom: 0,
		left: 0,
		borderTop: '1px solid #e8e8e8',
		backgroundColor: '#fff',
		textAlign: 'right',
	},
};

class UpdateForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isFetchingData: false,
			selectedItemTypeCode: null,
			unitOfMeasures: [],
			inputTypeCodes: [],
			examItemValue: [],
			examItemId: 0,
			analyzerDynamicForm: [],
			examItemAnalyzerValue: [],
			newAnalyzerIsTrue: false,
			resetAnalyzerIsTrue: false,
			examItemList: [],
			currentExamItem: '',
			isForceDeactivate: false,
		};

		this.formRef = React.createRef();
		this.dynamicForm = React.createRef();
	}

	async componentDidMount() {

		const unitOfMeasures = await fetchUnitOfMeasureItems();
		const activeUnitOfMeasures = (unitOfMeasures || []).filter(item => item.isActive === 1);
		const inputTypeCodes = await getInputTypeCode();

		this.setState({ unitOfMeasures: activeUnitOfMeasures, inputTypeCodes });
	}

	// for dynamic analyzer value
	handleAnalyzerValue = value => {
		this.setState({ analyzerDynamicForm: value });
	};

	async componentDidUpdate(prevProps) {
		const {
			selectedSectionId: secId,
			selectedSpecimenId: specId,
			selectedExamItemId: examItemId,
			selectedExamItemList,
			visible,
		} = this.props;

		const {
			selectedSectionId: prevSecId,
			selectedSpecimenId: prevSpecId,
			selectedExamItemId: prevExamItemId,
			visible: prevVisible,
		} = prevProps;

		const propsHasChanged =
			secId !== prevSecId || specId !== prevSpecId || examItemId !== prevExamItemId;

		const drawerOpened = !prevVisible && visible;

		const propsIsNotNull = secId !== null && specId !== null && examItemId !== null;

		// Note. This will run only when a prop has changed or drawer is reopened
		// for preventing an infinite rendering
		if ((propsHasChanged || drawerOpened) && propsIsNotNull) {
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ isFetchingData: true }, async () => {
				const examItem = await fetchExamItem(secId, specId, examItemId);
				console.log('running');
				console.log(examItem);

				if (examItem) {
					const { setFieldsValue } = this.formRef.current;
					const { examItemTypeCode } = examItem;
					const examItemValue = examItem.examItemValue || [];

					// Handle null or undefined analyzer codes
					const analyzerCodes = examItem.examItemAnalayzereCodes || [];
					this.setState({
						examItemAnalyzerValue: analyzerCodes,
						newAnalyzerIsTrue: true,
					});

					// First.
					// Assign value to the dynamic form only if the selected
					// type code is option or checkbox

					this.setState(
						{
							selectedItemTypeCode: examItemTypeCode,
							examItemValue,
							currentExamItem: examItem.examItemName,
						},
						() => {
							// Second.
							// Assign value to the fields that is always present on the form
							setFieldsValue({
								examItemName: examItem.examItemName,
								examItemGeneralName: examItem.examItemGeneralName,
								examItemTypeCode,
								examItemIntegrationCode: examItem.examItemIntegrationCode,
								active: examItem.active,
							});

							// Third.
							// Assign value to the fields that correspond to the selected
							// item type code. E.g Alpha numeric, textarea, etc.
							if (examItem.examItemTypeCode === EITC_ALPHA_NUMERIC) {
								setFieldsValue({ examItemUnitCode: examItem.examItemUnitCode });
							}

							if (
								examItem.examItemTypeCode === EITC_ALPHA_NUMERIC ||
								examItem.examItemTypeCode === EITC_NUMERIC ||
								examItem.examItemTypeCode === EITC_TEXT_AREA
							) {
								const defaultVal =
									examItemValue.length > 0 ? examItemValue[0].examItemValueLabel : null;
								setFieldsValue({ examItemTypeDefault: defaultVal });
							}

							// Fourth
							// Assign examItemId
							this.setState({ examItemId: examItem.examItemID });
						},
					);
				}

				this.setState({ isFetchingData: false });
				// Delay resetting newAnalyzerIsTrue to ensure DynamicFormAnalyzer receives the data
				setTimeout(() => {
					this.setState({ newAnalyzerIsTrue: false });
				}, 100);
			});
		}
	}


	onChangeItemTypeCode = itemTypeCode => {
		const { setFieldsValue } = this.formRef.current;

		if (itemTypeCode === EITC_NUMERIC) setFieldsValue({ examItemTypeDefault: '' });

		this.setState({ selectedItemTypeCode: itemTypeCode });
	};

	onSubmit = () => {
		const { selectedItemTypeCode, examItemId, analyzerDynamicForm } = this.state;
		const { onSuccess, selectedSectionId, selectedSpecimenId, selectedExamItemList } = this.props;
		const { getFieldsValue } = this.formRef.current;

		const fields = getFieldsValue();
		const trimmedName = (fields.examItemName || '').trim().toLowerCase();

		// Duplicate Name Validation (excluding current item)
		const isDuplicate = selectedExamItemList.some(
			item =>
				item.examItemID !== examItemId && item.examItemName.trim().toLowerCase() === trimmedName
		);

		if (isDuplicate) {
			message.info('Duplicate Exam Result Names are not allowed within the same SECTION and SPECIMEN');
			return;
		}

		// If checkbox or option get default & label in dynamic form
		if (selectedItemTypeCode === EITC_OPTION || selectedItemTypeCode === EITC_CHECKBOX) {
				const examItemValueParam = [];
				const checkKeys = this.dynamicForm.getCheckedItemKeys();
				const dynamicFields = this.dynamicForm.getFields();

				dynamicFields.forEach(item =>
					examItemValueParam.push({
						examItemValueDefault: checkKeys.includes(item.key) ? 1 : 0,
						examItemValueLabel: fields[`dynamicInputs_${item.key}`],
					}),
				);

				fields.examItemValue = examItemValueParam;
			}

			if (
				selectedItemTypeCode === EITC_ALPHA_NUMERIC ||
				selectedItemTypeCode === EITC_NUMERIC ||
				selectedItemTypeCode === EITC_TEXT_AREA
			) {
				if (fields.examItemTypeDefault) {
					fields.examItemValue = [
						{
							examItemValueDefault: 1,
							examItemValueLabel: fields.examItemTypeDefault,
						},
					];
				}
			}

			///checking analyzer if is no data or null
			const analyzerCheck = analyzerDynamicForm.map(item => {
				const analyzerData =
					item.analyzerID === null && item.analyzerName === '' && item.examItemAnalyzerCode === '';
				return analyzerData;
			});
			const AnalyzerIsNull = analyzerCheck.includes(true);

			const payload = {
				examItemId,
				examItemName: fields.examItemName,
				examItemGeneralName: fields.examItemGeneralName,
				examItemTypeCode: fields.examItemTypeCode,
				examItemIntegrationCode: fields.examItemIntegrationCode,
				examItemUnitCode: fields.examItemUnitCode,
				examItemValue: fields.examItemValue,
				sectionID: selectedSectionId,
				specimenID: selectedSpecimenId,
				active: fields.active === false ? 0 : 1,
				examItemAnalayzereCodes: AnalyzerIsNull === true ? [] : analyzerDynamicForm,
			};

			showIntegrationCodeModal(fields.examItemIntegrationCode, {
				currentItemId: examItemId,
				onConfirm: () => {
					this.setState({ isLoading: true }, async () => {
						if (fields.active === false && this.state.isForceDeactivate) {
							await deactivateItem('Exam Result', examItemId);
						}

						const updatedExamItem = await updateExamItem(payload);
						this.setState({ isLoading: false, isForceDeactivate: false });
						if (updatedExamItem) {
							onSuccess();
							// this.resetAnalyzer();
						}
					});
				}
			});
	};

	resetAnalyzer = () => {
		this.setState({ analyzerDynamicForm: [], resetAnalyzerIsTrue: true });

		// set isTrue back to false after 0.5 milliseconds
		setTimeout(() => {
			this.setState({ resetAnalyzerIsTrue: false });
		}, 500);
	};

	resetForm = () => {
		const { resetFields } = this.formRef.current;
		resetFields();
		this.setState({
			selectedItemTypeCode: null,
			examItemValue: [],
			examItemId: 0,
			currentExamItem: '',
			isForceDeactivate: false,
		});
	};

	onCancel = () => {
		const { onClose } = this.props;
		this.resetForm();
		this.resetAnalyzer();
		onClose();
	};

	render() {
		const {
			isLoading,
			selectedItemTypeCode,
			unitOfMeasures,
			inputTypeCodes,
			isFetchingData,
			examItemValue,
			examItemId,
			examItemAnalyzerValue,
			resetAnalyzerIsTrue,
			newAnalyzerIsTrue,
			// examItem,
		} = this.state;

		const { onClose, visible, selectedSectionName, selectedSpecimenName } = this.props;
		const UnitMeasureOptions = unitOfMeasures.map(unit => {
			const code = unit.unitOfMeasureCode || unit.code || unit.Code;
			const base = unit.unitOfMesureBase || unit.unitOfMeasureBase || unit.base || unit.Base;
			const label = base ? `${code} - ${base}` : code;

			return (
				<Option value={code} key={code}>
					{label}
				</Option>
			)
		});

		const InputTypeCodeOptions = inputTypeCodes.map(typeCode => (
			<Option value={typeCode.inputTypeCode} key={typeCode.inputTypeCode}>
				{typeCode.inputTypeName}
			</Option>
		));

		return (
			<Drawer
				title={`${drawerTitle.update} - ${selectedSectionName} / ${selectedSpecimenName}`.toUpperCase()}
				width="50%"
				placement="right"
				closable
				onClose={this.onCancel}
				visible={visible}
			>
				<Form
					ref={this.formRef}
					onFinish={this.onSubmit}
					className="exam-item-update-form"
					layout="vertical"
					autoComplete="off"
				>
					<Spin tip="Loading..." spinning={isFetchingData}>
						<section style={{ marginBottom: 60 }}>
							<Form.Item name="active" valuePropName="checked" label="STATUS">
								<Switch
									onChange={checked => {
										if (!checked) {
											const { examItemId } = this.state;
											const { setFieldsValue } = this.formRef.current;
											const { onClose } = this.props;

											showDeactivationModal('Exam Result', examItemId, {
												itemLabel: 'Exam Result',
												onConfirm: isForce => {
													setFieldsValue({ active: false });
													this.setState({ isForceDeactivate: isForce });
												},
												onCancel: () => {
													setFieldsValue({ active: true });
													this.setState({ isForceDeactivate: false });
												},
											});
										}
									}}
								/>
							</Form.Item>
							<Row
								style={{
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<Form.Item
									name="examItemName"
									label={fieldLabels.examItemName}
									rules={fieldRules.examItemName}
									style={{ width: '32%' }}
								>
									<RegexInput regex={/[A-z0-9 -]/} maxLength={200} />
								</Form.Item>
								<Form.Item
									name="examItemGeneralName"
									label={fieldLabels.examItemGeneralName}
									rules={fieldRules.examItemGeneralName}
									style={{ width: '32%' }}
								>
									<RegexInput regex={/[A-z0-9 -]/} maxLength={50} />
								</Form.Item>
								<Form.Item
									name="examItemIntegrationCode"
									label={fieldLabels.examItemIntegrationCode}
									rules={fieldRules.integrationCode}
									style={{ width: '32%' }}
								>
									<Input maxLength={20} />
								</Form.Item>
							</Row>
							<Form.Item
								name="examItemTypeCode"
								label={fieldLabels.examItemTypeCode}
								rules={fieldRules.examItemType}
								style={{ width: '32%' }}
							>
								<Select onChange={this.onChangeItemTypeCode}>{InputTypeCodeOptions}</Select>
							</Form.Item>
							{selectedItemTypeCode === EITC_ALPHA_NUMERIC && (
								<div
									style={{
										display: 'flex',
										gap: '15px',
									}}
								>
									<Form.Item
										name="examItemUnitCode"
										label={fieldLabels.examItemUnitCode}
										rules={fieldRules.unitOfMeasure}
									>
										<Select allowClear>{UnitMeasureOptions}</Select>
									</Form.Item>
									<Form.Item
										name="examItemTypeDefault"
										label={fieldLabels.examItemTypeDefault}
										rules={fieldRules.examItemTypeDefault}
									>
										<AlphaNumInput maxLength={254} />
									</Form.Item>
								</div>
							)}
							{selectedItemTypeCode === EITC_NUMERIC && (
								<div
									style={{
										display: 'flex',
										gap: '15px',
									}}
								>
									<Form.Item
										name="examItemUnitCode"
										label={fieldLabels.examItemUnitCode}
										rules={fieldRules.unitOfMeasure}
										style={{ width: '32%' }}
									>
										<Select allowClear>{UnitMeasureOptions}</Select>
									</Form.Item>
									<Form.Item
										name="examItemTypeDefault"
										label={fieldLabels.examItemTypeDefault}
										rules={fieldRules.examItemTypeDefault}
										style={{ width: '32%' }}
									>
										<NumberInput maxLength={254} />
									</Form.Item>
								</div>
							)}
							{(selectedItemTypeCode === EITC_CHECKBOX || selectedItemTypeCode === EITC_OPTION) && (
								<Form.Item shouldUpdate>
									{form => {
										return (
											<DynamicForm
												ref={inst => (this.dynamicForm = inst)}
												form={form}
												examItemValue={examItemValue}
												examId={examItemId}
												allowMultipleDefaults={selectedItemTypeCode === EITC_CHECKBOX}
											/>
										);
									}}
								</Form.Item>
							)}
							{selectedItemTypeCode === EITC_TEXT_AREA && (
								<Form.Item
									name="examItemTypeDefault"
									label={fieldLabels.examItemTypeDefault}
									rules={fieldRules.examItemTypeDefault}
								>
									<TextArea maxLength={100} />
								</Form.Item>
							)}
							<DynamicFormAnalyzer
								handleAnalyzerValue={this.handleAnalyzerValue}
								handleExistingData={examItemAnalyzerValue}
								newAnalyzerIsTrue={newAnalyzerIsTrue}
								resetAnalyzerIsTrue={resetAnalyzerIsTrue}
							/>
						</section>
					</Spin>

					<section style={styles.footer}>
						<div>
							<Button shape="round" style={{ margin: 10, width: 120 }} onClick={this.onCancel}>
								{buttonNames.cancel}
							</Button>
							<UserAccessContext.Consumer>
								{value =>
									value.userAccess.settings.create && (
										<Button
											shape="round"
											type="primary"
											htmlType="submit"
											loading={isLoading}
											style={{ margin: 10, width: 120 }}
										>
											{buttonNames.update}
										</Button>
									)
								}
							</UserAccessContext.Consumer>
						</div>
					</section>
				</Form>
			</Drawer>
		);
	}
}

UpdateForm.propTypes = {
	onClose: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
	onSuccess: PropTypes.func.isRequired,
	selectedSectionId: PropTypes.number,
	selectedSpecimenId: PropTypes.number,
	selectedExamItemId: PropTypes.number,
	selectedSectionName: PropTypes.string,
	selectedSpecimenName: PropTypes.string,
};

UpdateForm.defaultProps = {
	selectedSectionId: null,
	selectedSpecimenId: null,
	selectedExamItemId: null,
	selectedSectionName: null,
	selectedSpecimenName: null,
};

export default UpdateForm;
